import { jsx as _jsx } from "react/jsx-runtime";
import { PPCPositionTypesUK } from '@as-react/common-types';
import { isNullOrUndefined } from '@as-react/common-utils';
import { Box } from '@yonderland/andes-react';
import { HtmlInclude } from '../../common/html-include/HtmlInclude';
import { useProductPlacementCopyBox } from './useProductPlacementCopyBox';
export const ProductPlacementCopyBox = ({ ppc }) => {
    const { content, renderedContainerElement, PPCPositionTypes, isExternal } = useProductPlacementCopyBox(ppc);
    if (isNullOrUndefined(content) || content.length === 0)
        return null;
    const getOuterSpacings = () => {
        if (isExternal()) {
            if (ppc.placementPositionId === PPCPositionTypesUK.DIGITAL_PARTNER_MESSAGING) {
                return {
                    paddingBlockEnd: '4',
                };
            }
            return {};
        }
        const paddingBlockStart = ppc.placementPositionId === PPCPositionTypes.ABOVE_BUY_BUTTON
            ? '2'
            : ppc.placementPositionId === PPCPositionTypes.BELOW_BUY_BUTTON
                ? '4'
                : '0';
        const paddingBlockEnd = ppc.placementPositionId === PPCPositionTypes.ABOVE_DESCRIPTION ? '6' : '4';
        return {
            paddingBlockStart,
            paddingBlockEnd,
        };
    };
    const getInnerBoxProps = () => {
        if (isExternal()) {
            return {};
        }
        return {
            backgroundColor: 'warning-bg',
            paddingBlock: '2',
            paddingInline: {
                base: '4',
                md: '2',
            },
            marginInline: { base: '-4', md: '-8' },
        };
    };
    if (isExternal()) {
        return (_jsx(Box, Object.assign({}, getOuterSpacings(), { children: _jsx("div", { ref: renderedContainerElement, children: _jsx(HtmlInclude, { htmlFragment: content }) }) })));
    }
    return (_jsx(Box, Object.assign({}, getOuterSpacings(), { children: _jsx(Box, Object.assign({}, getInnerBoxProps(), { children: _jsx("div", { ref: renderedContainerElement, children: _jsx(HtmlInclude, { htmlFragment: content }) }) })) })));
};
